import { Avatar, Badge, Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  textStyle: {
    color: theme.Colors.greyLight,
    textWrap: 'wrap'
  },
  avatarStyle: {
    height: 42,
    width: 42
  },
  badgeStyle: {
    marginLeft: theme.MetricsSizes.tiny_xxx,
    '& .MuiBadge-badge': {
      background: theme.Colors.redPrimary,
      fontSize: theme.MetricsSizes.tiny_xx,
      fontWeight: theme.fontWeight.regular,
      padding: theme.spacing(1, 0),
      color: theme.Colors.white
    }
  }
}));
type Props = {
  avatarImg?: string;
  title: string;
  subTitle?: string;
  renderComponent?: () => JSX.Element;
  avatarClassNameStyles?: any;
  titleStyle?: React.CSSProperties;
  isBadgeEnable?: boolean;
  listStyle?: React.CSSProperties;
  isLink?: any;
  state?: any;
};

const ListItemCell = (props: Props) => {
  const classes = useStyles();
  const theme = useTheme();

  const {
    avatarImg,
    subTitle,
    title,
    renderComponent,
    avatarClassNameStyles,
    titleStyle,
    isBadgeEnable = false,
    listStyle,
    isLink,
    state
  } = props;

  return (
    <Grid
      container
      alignItems="center"
      style={{
        ...listStyle
      }}
    >
      {avatarImg && (
        <Grid item style={{ marginRight: theme.MetricsSizes.small_xxx }}>
          <Avatar
            src={avatarImg}
            className={`${classes.avatarStyle} ${avatarClassNameStyles}`}
          />
        </Grid>
      )}
      <Grid item xs>
        <Grid
          style={{
            display: 'flex',
            flexWrap: 'wrap'
          }}
        >
          {isLink ? (
            <Link
              to={isLink}
              state={state}
              style={{
                color: theme.Colors.blackPrimary,
                fontSize: theme.MetricsSizes.small_xxx,
                fontWeight: theme.fontWeight.regular
              }}
            >
              <Typography
                style={{
                  fontWeight: theme.fontWeight.medium,
                  color: theme.Colors.blackMedium,
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word',
                  ...titleStyle
                }}
              >
                {title}
              </Typography>
            </Link>
          ) : (
            <Typography
              style={{
                fontWeight: theme.fontWeight.medium,
                color: theme.Colors.blackMedium,
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
                ...titleStyle
              }}
            >
              {title}
            </Typography>
          )}
          {isBadgeEnable && (
            <Badge
              overlap="circular"
              badgeContent={'Kgs'}
              className={classes.badgeStyle}
            />
          )}
        </Grid>

        {subTitle && (
          <Typography variant="subtitle2" className={classes.textStyle}>
            {subTitle}
          </Typography>
        )}
        {renderComponent && renderComponent()}
      </Grid>
    </Grid>
  );
};
export default ListItemCell;
